import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { getLanguageChipLabel, getLanguageLabel } from 'src/data/generation';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  availableBrandTermsCount: PropTypes.number.isRequired,
  activeBrandVoiceCount: PropTypes.number.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  brandVoiceExistForLanguage: PropTypes.bool,
};

const defaultProps = {
  className: null,
  brandVoiceExistForLanguage: false,
};

export const EmptyTermsBanner = ({
  className,
  availableBrandTermsCount,
  activeBrandVoiceCount,
  onCtaClick,
  language,
  brandVoiceExistForLanguage,
}) => {
  const styles = useStyles();

  const { title, description, cta } = (() => {
    if (availableBrandTermsCount > 0 && activeBrandVoiceCount === 0) {
      return {
        title: 'Brand vocabulary is disabled',
        cta: 'Enable brand vocabulary',
      };
    } else if (availableBrandTermsCount === 0) {
      return {
        title: `No brand vocabularies in ${getLanguageLabel(language)} (${getLanguageChipLabel(
          language
        )})`,
        description:
          'Set clear guidelines by flagging terms you would like Anyword to\nuse and terms you would like Anyword to refrain from using',
        cta: brandVoiceExistForLanguage ? 'New brand vocabulary' : 'New brand voice',
      };
    }
    return {};
  })();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium12}
      >
        {title}
      </CustomTypography>

      {description && (
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph12}
        >
          {description}
        </CustomTypography>
      )}

      {cta && onCtaClick && (
        <ButtonText
          className={styles.buttonCta}
          onClick={onCtaClick}
        >
          {cta}
        </ButtonText>
      )}
    </div>
  );
};

EmptyTermsBanner.propTypes = propTypes;
EmptyTermsBanner.defaultProps = defaultProps;
